"use client";

import { styled } from "styled-components";

import { poppins_body_md_medium } from "../../font/poppins/body";
import { poppins_heading_lg } from "../../font/poppins/heading";

export const Content = styled.div`
  width: 48rem;
  position: relative;
  padding: var(--Spacing-20, 2rem);
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-12, 1.2rem);
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Primary, #7c899c);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.16), 0 0 8px 0 rgba(0, 0, 0, 0.12);
  background: var(--Color-Common-Bg-Primary, #fff);
  margin: 0 auto;
`;

export const Title = styled.div<{ $isWarning: boolean }>`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${poppins_heading_lg}
`;

export const Description = styled.div`
  padding: var(--Spacing-4, 0.4rem) 0rem;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${poppins_body_md_medium}
`;

export const CancelButton = styled.button`
  display: flex;
  height: var(--Size-Btn-Placeholder-Md, 4rem);
  max-width: 21rem;
  max-height: var(--Size-Btn-Lg, 4.8rem);
  padding: var(--Spacing-Btn-8, 0.8rem) var(--Spacing-Btn-16, 1.6rem);
  justify-content: center;
  align-items: center;
  gap: var(--Spacing-Btn-4, 0.4rem);
  flex: 1 0 0;
  color: var(--Color-Common-Text-Interactive-Secondary, #515c6c);
  text-align: center;
  ${poppins_body_md_medium}

  &:hover {
    color: var(--Color-Common-Text-Interactive-Secondary-Hovered, #3d4551);
  }

  &:active {
    color: var(--Color-Common-Text-Interactive-Secondary-Pressed, #2a2f37);
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 44rem;
  padding-top: 0.8rem;
  gap: 2rem;
`;

export const SubmitButton = styled.button<{ $isWarning: boolean }>`
  display: flex;
  height: var(--Size-Btn-Placeholder-Md, 4rem);
  max-width: 21rem;
  max-height: var(--Size-Btn-Lg, 4.8rem);
  padding: var(--Spacing-Btn-8, 0.8rem) var(--Spacing-Btn-16, 1.6rem);
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: var(--Spacing-Btn-4, 0.4rem);
  flex: 1 0 0;
  border-radius: var(--Border-Radius-4, 0.4rem);
  background: ${({ $isWarning }) =>
    $isWarning
      ? "var(--Color-Common-Bg-Interactive-Warning, #E53E06)"
      : "var(--Color-Common-Bg-Interactive-Primary, #1baefe)"};
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  ${poppins_body_md_medium}

  &:hover {
    background: ${({ $isWarning }) =>
      $isWarning
        ? "var(--Color-Common-Bg-Interactive-Warning-Hovered, #B83205)"
        : "var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9)"};
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
      0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  }

  &:active {
    background: ${({ $isWarning }) =>
      $isWarning
        ? "var(--Color-Common-Bg-Interactive-Warning-Pressed, #8B2504)"
        : "var(--Color-Common-Bg-Interactive-Primary-Pressed, #017abc)"};
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08) inset,
      0px 0px 2px 0px rgba(0, 0, 0, 0.06) inset;
  }
`;
